"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateTransactionStatuses = void 0;
var pay_api_1 = require("@l2p/pay-api");
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var useGenerateTransactionStatuses = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        return Object.values(pay_api_1.TransactionTypeEnum).map(function (key) { return ({
            label: t(key),
            value: key,
        }); });
    }, [t]);
};
exports.useGenerateTransactionStatuses = useGenerateTransactionStatuses;
